/* eslint react/forbid-prop-types: 0 */
/* eslint react/prop-types: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from 'uuid/v4';
import { numberWithCommas } from '../../../util/CommonUtils';
import LineChart from '../../common/Charts/LineChart';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

class TrendGraphView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      selectedDropdown: 'Total',
      columnkeyValuIndex: [],
    };
  }

  componentDidMount() {
    this.categorieData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.studyInfo !== this.props.studyInfo) {
      this.setState({ studyInfo: nextProps.studyInfo }, () =>
        this.categorieData(),
      );
    }
  }

  categorieData = () => {
    const categories = [];
    if (Array.isArray(this.props.studyInfo)) {
      for (let i = 0; i < this.props.studyInfo.length; i += 1) {
        categories.push(this.props.studyInfo[i][0].studyDescription);
      }
    }
    const columnVal = [];
    this.props.data[0].columnHeaderList.map(element => {
      columnVal.push(element.label);
      return false;
    });
    this.setState({ columnkeyValuIndex: columnVal });
    this.setState({ categories });
  };

  checkDDNHCS(val) {
    const { selectedKPIsTitle, allSelectedKPIsInfo } = this.props;
    let ddNHCS = false;
    for (const key in selectedKPIsTitle) {
      if (
        selectedKPIsTitle[key] === val &&
        allSelectedKPIsInfo[key] &&
        allSelectedKPIsInfo[key].modeled
      ) {
        ddNHCS = allSelectedKPIsInfo[key].modeled;
      }
    }
    return ddNHCS;
  }

  processData = data => {
    const outPut = [];
    const metricsList = this.props.cellElementList.map(item => { return item.isVisible; });
    if (
      data &&
      data[0] &&
      data[0].crosstabPerStudy &&
      data[0].crosstabPerStudy[0]
    ) {
      let rowIndex = 0;
      const studyData = data[0].crosstabPerStudy[0];
      const indexVal = this.state.columnkeyValuIndex.indexOf(
        this.state.selectedDropdown,
      );
      if (studyData && studyData[0] && studyData[0].rowList) {
        studyData[0].rowList.forEach(element => {
          const object = {};
          object.name = `<lable title = "${element.tooltipVal ? element.tooltipVal :
             element.rowHeader}"> ${element.rowHeader.substring(0, 50)} </label>`; 
             // element.rowHeader.substring(0, 50);
          object.marker = { symbol: 'circle' };
          const dataVal = [];
          let studyIndex = 0;

          this.state.categories.forEach(category => {
            const data1 = {};
            let productNo = this.props.studyInfo[0][0].pn;
            this.props.studyInfo.forEach(studyObj => {
              if (studyObj[0].studyDescription === category) {
                productNo = studyObj[0].pn;
              }
            });
            const selectedTrendsKPIsInfo = this.props.selectedTrendsKPIsInfo ? 
            this.props.selectedTrendsKPIsInfo[productNo] : {};
            let ddNHCS = false;
            for (const key in selectedTrendsKPIsInfo) {
              if (selectedTrendsKPIsInfo[key].header === element.rowHeader) {
                ddNHCS = selectedTrendsKPIsInfo[key].modeled;
              }
            }
            data1.name = ddNHCS
              ? `<lable title = ${element.rowHeader}> ${String.fromCharCode(10020)} ${element.rowHeader} </label>`
              : `<lable title = ${element.rowHeader}> ${element.rowHeader} </label>`; // element.rowHeader;
            let selectedBaseName = data[0].selectedBaseName;
            if (data[0].selectedBaseGroup === 'standard-base') {
              const selectedBase = this.props.standardBaseLists
              .filter(base => base.expression === data[0].selectedBaseNode);
              selectedBaseName = selectedBase[0].label.toUpperCase();
            }
            const filteredStudyData = data[0].crosstabPerStudy[studyIndex] ?
              data[0].crosstabPerStudy[studyIndex].filter(elem =>
                elem.filter === selectedBaseName) : [];
            const cellListVal = filteredStudyData[0] ?
              filteredStudyData[0].rowList[rowIndex].cellList[indexVal] : null;
            if (cellListVal && cellListVal !== 'Not Valid') {
              data1.y = parseInt(
                cellListVal.vertical.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, ''),
              );
              data1.value = {};
              if(metricsList[0]) {
                data1.value.sample = numberWithCommas(cellListVal.sample);
              }
              if(metricsList[1]) {
                data1.value.weighted = numberWithCommas(cellListVal.weighted);
              }
              if(metricsList[2]) {
                data1.value.vertical = cellListVal.vertical.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
              }
              // data1.value = {
              //   vertical: cellListVal.vertical.replace(
              //     /[&\/\\#,+()$~%'":*?<>{}]/g,
              //     '',
              //   ),
              //   sample: numberWithCommas(cellListVal.sample),
              //   weighted: numberWithCommas(cellListVal.weighted),
              // };
            }
            dataVal.push(data1);
            studyIndex += 1;
          });
          rowIndex += 1;
          object.data = dataVal;
          outPut.push(object);
        });
      }
    }
    return outPut;
  };

  handleDropdownChange = e => {
    this.setState({ selectedDropdown: e.currentTarget.value });
    /*
      this.props.runReport(null, null, `${this.state.selectedReportType}_${e.currentTarget.value}`);
      this.setState({ selectedDropdown: e.currentTarget.value }, () => {
        this.props.handleExportParams(this.state.selectedRadioButton, undefined, undefined);
      }); */
  };

  renderDropdown = () =>
    this.props.data[0].columnHeaderList.map(val => (
      <option value={val.label} key={uuid()} title={val.tooltipVal ? val.tooltipVal : val.label}>
        {this.checkDDNHCS(val.label) ? `${String.fromCharCode(10020)} ${val.label}` : val.label}
      </option>
    ));

  render() {
    const dataVal = this.props.data;
    const chartTooltip = [];
    const metricsList = this.props.cellElementList.map(item => { return item.isVisible; });
    if(metricsList[0]) {
      chartTooltip.push('Sample');
    }
    if(metricsList[1]) {
      chartTooltip.push('Weighted');
    }
    if(metricsList[2]) {
      chartTooltip.push('Vertical');
    }
    return (
      <div>
        <div className="row expanded">
          <div className="large-12 column">
            <div className="p-graphView">
              <div className="row expanded trendGraphHeader">
                <div className="large-4 pull-left padding-5-10">
                  Total: Vertical %
                </div>
                <div className="large-4 pull-left">
                  <select
                    onChange={this.handleDropdownChange}
                    value={this.state.selectedDropdown}
                  >
                    {this.renderDropdown()}
                  </select>
                </div>
                <div className="large-4 pull-left text-left">
                  <div className="close-button hidden" />
                </div>
              </div>
              <LineChart
                chartColor={chartColor}
                yLabel={'Y-Label'}
                data={{
                  series: this.processData(dataVal),
                  tooltip: chartTooltip,
                }}
                dataLabels
                categories={this.state.categories}
                tickPlacement={'on'}
                legend={{
                  enabled: true,
                  align: 'left',
                  verticalAlign: 'top',
                  layout: 'vertical',
                  useHTML: true,
                  x: 0,
                  y: 0,
                  title: {
                    text: 'Trend Rows',
                  },
                  symbolPadding: 15,
                  symbolWidth: 0,
                  symbolRadius: 0,
                  lineHeight: 32,
                  itemStyle: {
                    color: 'RGB(48, 67, 93)',
                    fontSize: '12px',
                    fontWeight: 'normal',
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TrendGraphView.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      columnHeaderList: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  ),
  standardBaseLists: PropTypes.arrayOf(PropTypes.object),
  // studyInfo: PropTypes.arrayOf(PropTypes.shape({})),
  studyInfo: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  ]),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    data: state.crosstab.crosstabTableList,
    standardBaseLists: state.crosstab.standardBaseLists,
    studyInfo: state.crosstab.crosstabTableList[0].crosstabPerStudy,
    selectedKPIsTitle: state.crosstab.selectedKPIsTitle,
    allSelectedKPIsInfo: state.crosstab.allSelectedKPIsInfo,
    selectedTrendsKPIsInfo: state.crosstab.selectedTrendsKPIsInfo,
  };
}

export default connect(mapStateToProps)(TrendGraphView);
